/** Extract a user-facing message from axios/API errors (handles unwrapped response bodies). */
export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong",
): string {
  if (!error) return fallback;
  if (typeof error === "string" && error.trim()) return error.trim();

  const err = error as {
    message?: string;
    response?: { data?: unknown };
  };

  const payload = err.response?.data ?? error;
  if (typeof payload === "string" && payload.trim()) return payload.trim();

  const data = payload as { message?: string | string[] };
  const message = data?.message;

  if (Array.isArray(message)) {
    const parts = message
      .map((item) => (typeof item === "string" ? item.trim() : String(item)))
      .filter(Boolean);
    if (parts.length) return parts.join(", ");
  }

  if (typeof message === "string" && message.trim()) return message.trim();

  if (typeof err.message === "string" && err.message.trim()) {
    return err.message.trim();
  }

  return fallback;
}

const HANDOVER_RECALL_WARNING_DELAY_MS = 3000;

/** Success snackbar first; optional recall scheduling warning after a short delay. */
export function notifyHandoverSaveResult(
  enqueueSnackbar: (
    message: string,
    options?: { variant?: "default" | "error" | "success" | "warning" | "info" },
  ) => void,
  successMessage: string,
  recallWarning?: string | null,
): void {
  enqueueSnackbar(successMessage, { variant: "success" });
  const warning = recallWarning?.trim();
  if (!warning) return;
  window.setTimeout(() => {
    enqueueSnackbar(warning, { variant: "warning" });
  }, HANDOVER_RECALL_WARNING_DELAY_MS);
}

export const getCharAtName = (name: string) =>
  name && name.charAt(0).toUpperCase();

export const capitalizeFirstLetter = (name: string) =>
  name.charAt(0).toUpperCase() + name.slice(1);

export const getComparator = (order: "asc" | "desc", orderBy: string) => {
  const orderName = orderBy.split(".");
  if(orderName.length > 1) {
    return order === "desc"
     ? (a: any, b: any) => (b[orderName[0]][orderName[1]] < a[orderName[0]][orderName[1]] ? -1 : 1)
      : (a: any, b: any) => (a[orderName[0]][orderName[1]] < b[orderName[0]][orderName[1]] ? -1 : 1);
  }
  return order === "desc"
    ? (a: any, b: any) => (b[orderBy] < a[orderBy] ? -1 : 1)
    : (a: any, b: any) => (a[orderBy] < b[orderBy] ? -1 : 1);
};
